export const CHARACTER_LIST_REQUEST = "CHARACTER_LIST_REQUEST";
export const CHARACTER_LIST_SUCCESS = "CHARACTER_LIST_SUCCESS";
export const CHARACTER_LIST_FAIL = "CHARACTER_LIST_FAIL";
export const CHARACTER_DETAIL_REQUEST = "CHARACTER_DETAIL_REQUEST";
export const CHARACTER_DETAIL_SUCCESS = "CHARACTER_DETAIL_SUCCESS";
export const CHARACTER_DETAIL_FAIL = "CHARACTER_DETAIL_FAIL";
